import ENV from 'rise-ui/config/environment.js';
import { join } from 'rise-ui/utils/string.js';

const MAP = ENV.APP.API.MAP;
let url;
export function mapUrl() {
  return url ??= join([ MAP.EXPOSED_URL, 'rise-map' ], '/');
}

export function mapOpen(target) {
  window.open(mapUrl(), target || '_blank');
}

export function mapLocationUrl(type, locationId) {
  const query
    = type === 'point' ? MAP.POINT
    : type === 'line' ? MAP.LINE
    : type === 'area' ? MAP.AREA
    : `_unknown_geometry__${type}_`;
  locationId = locationId || `_unknown_location__${locationId}_`;
  return `${mapUrl()}${query}${locationId}`;
}

export function mapDataUrl() {
  const query = MAP.DATA;
  return `${mapUrl()}${query}mapData`;
}
